import { CircularProgress, Grid } from '@mui/material';
import React, { useEffect } from 'react';
import { HomeService } from '../../../Component/Api/Home/HomeService';
import { ModuleSummaryDto } from '../../../Component/Model/Dto/Home/Home';
// import BEE123 from "../../../../public/img/BEE123Red.png";
// import EE123 from "../../../../public/img/EE123_Logo.png";
// import WSP123 from "../../../../public/img/WSP123_logo.png";
import config from '../../../config';
import { InfoCard } from './InfoCard';

export const ModuleInfoCards = () => {

    const [BEEInfo, setBEEInfo] = React.useState<ModuleSummaryDto.SummaryItem>();
    const [EEInfo, setEEInfo] = React.useState<ModuleSummaryDto.EESummaryItem>();
    const [isLoading, setIsLoading] = React.useState(false);

    const WSPInfo: ModuleSummaryDto.SummaryItem = {
        title: "WSP / ATR Module",
        numberOfScorecards: -1
    };

    const fetchInfo = async () => {
        setIsLoading(true);
        try {
            let response = await HomeService.getModuleSummary();
            setBEEInfo({
                ...response.data.beeModule,
                "title": "B-BBEE Module"
            });
            setEEInfo({
                ...response.data.employmentEquityModule,
                "title": "EE Module"
            });
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchInfo();
    }, []);

    const RenderContent = () => {
        if (isLoading) {
            return (
                <Grid container justifyContent="center" mb={5}>
                    <CircularProgress />
                </Grid>
            )
        }
        else {
            return (
                <Grid container spacing={5} mb={2}>
                    {BEEInfo && <InfoCard item={BEEInfo} content={`${BEEInfo.numberOfScorecards} Scorecards`} color={"#d64556"} redirectTo={config.enable_react_migration === "true" ? "bee/scorecardLicense" : config.publicUrl} logo={`${process.env.PUBLIC_URL}/img/BEE123Red.png`} isExternal={config.enable_react_migration === "true" ? false : true} />}
                    {EEInfo && <InfoCard item={EEInfo} content={`${EEInfo.numberOfScorecards} Scorecards`} color={"#2e94d1"} redirectTo={'ee/base'} logo={`${process.env.PUBLIC_URL}/img/EE123_Logo.png`} />}
                    {WSPInfo && <InfoCard item={WSPInfo} content={"Coming Soon..."} color={"#233f96"} redirectTo={config.enable_WSPATR === "true" ? "wsp/base" : ""} logo={`${process.env.PUBLIC_URL}/img/WSP123_logo.png`} isExternal={false} />}
                </Grid>
            )
        }
    }

    return (
        <>
            {RenderContent()}
        </>
    )
}
